// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuFilterNamePrompt .saltText-warning{padding:var(--salt-spacing-400) 0}.vuuFilterNamePrompt .saltDialogContent{background:0 0;padding:0}.vuuFilterNamePrompt .saltDialogContent .saltDialogContent-inner{padding:var(--vuuFilterNamePrompt-content-padding,1px)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
